/**
 * Wallet helpers for the simplified public flow.
 *
 * The wallet is a plain address attached to the authenticated X/Osteon
 * account — a profile/destination field only. It is never connected via a
 * provider and never signed: pasting an address proves nothing about
 * ownership, and it is never used as authentication.
 */
export const isValidAddress = (s) => /^0x[a-fA-F0-9]{40}$/.test((s || "").trim());

export const normalizeAddress = (s) => (s || "").trim().toLowerCase();
